import { Logo, Menu } from "@gamesheet/ui"
import styled from "styled-components"

import ScheduleIcon from '@mui/icons-material/DateRange';
import RosterIcon from '@mui/icons-material/Groups';
import StatsIcon from '@mui/icons-material/Scoreboard';
import MessagesIcon from '@mui/icons-material/Comment';

import { useEffect, useState } from "react";
import { useAppState } from "@/state/app/useAppState";
import { NavLink, useParams } from "react-router-dom";
import { useDeviceState } from "@/state/device/useDeviceState";
import { NavButton } from "@/components/pure/NavButton";

const StyledBottomNavigation = styled.div`
width: 100vw;
height: 100px;
background-color: ${props => props.theme.primaryColor};
color: ${props => props.theme.textOnSecondaryColor};
position: fixed;
bottom: 0;
left: 0;
z-index: 1000;
box-shadow: 0 -5px 5px 0px rgba(0,0,0,0.2);

.navigation-logo {
    margin-top: -10px;
    border-radius: 5px 5px 0 0;
    box-shadow: 0px -5px 5px 0px rgba(0,0,0,0.2);
    
    img {
        border-radius: 5px 5px 0 0;
    }
}
`

const StyledTopNavigation = styled.div`
display: none;
width: 100%;
height: 73px;
color: ${props => props.theme.textOnSecondaryColor};
position: fixed;
top: 87px;
z-index: 50;
border-radius: 0 0 5px 5px;

.inner-navigation {
    border-radius: 0 0 5px 5px;
    margin: 0 auto;
    max-width: 1280px;
    box-shadow: 0 5px 5px 0px rgba(0,0,0,0.2);
}
`

const InnerNavigation = styled.div.attrs({
    className: "inner-navigation"
})`
display:flex;
width: 100%;
justify-content: space-between;
height: 73px;
background-color: ${props => props.theme.secondaryColor};
`

const Tabs = styled.div.attrs({
    className: "tabs"
})`
flex: 2;
display: flex;
align-items: center;
z-index: 75;
`

const Tab = styled.div.attrs({
    className: "tab"
})`
width: 50%;
text-align: center;
font-size: 0.8rem;
z-index: 75;

a { 
    color: ${props => props.theme.textOnSecondaryColor};
    text-decoration: none;
}

a.active, a:hover { 
    color: ${props => props.theme.primaryColor};
    text-decoration: none;
}
`

const NavigationLogo = styled.div.attrs({
    className: "navigation-logo"
})`
flex: 1;
max-width: 100px;
text-align: center;
z-index: 1000;
background-color: ${props => props.theme.secondaryColor};

img {
    height: 50px;
    margin: 12px 12px 0 12px;
}

`

export function MobileTabs(){
    
    const app = useAppState()
    const device = useDeviceState()
    const Navigation = device.isMobile ? StyledBottomNavigation : StyledTopNavigation;

    const leftButtons = app.navigation.leftMobileItems()
    const rightButtons = app.navigation.rightMobileItems()
    const iconButton = app.navigation.iconMobileItem()

    useEffect(() => {
        app.menu.close();
    }, [])

    return <>
        <Navigation>
            <InnerNavigation>
                {device.isMobile && <>
                    <Tabs>
                        {leftButtons.map((button, index) => (
                            <Tab key={index}>
                                <NavButton button={button} size="sm" />
                            </Tab>
                        ))}
                    </Tabs>
                    <NavigationLogo onClick={()=>iconButton?.to && app.navigate(iconButton.to)}>
                        {/* embed svg instead of making a network request */}
                        <img alt="logo" src="data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg viewBox='58.036 58.039 110 99.688' xmlns='http://www.w3.org/2000/svg'%3e %3cg fill='%23fec307'/%3e %3cpath d='m159.664 148.701v-2.501l-2.467 2.753z' fill='%23fec307'/%3e %3cpath d='m166.3239 60.7781a463.0489 463.0489 0 0 0 -52.9468-2.7312 484.9277 484.9277 0 0 0 -53.7464 2.7368 1.8046 1.8046 0 0 0 -1.5947 1.7989v93.324a1.8054 1.8054 0 0 0 2.02 1.8c5.9342-.7171 24.6653-2.6721 52.5137-2.6721a476.1152 476.1152 0 0 1 53.3257 2.681 1.8067 1.8067 0 0 0 2.0154-1.8v-93.3393a1.8036 1.8036 0 0 0 -1.5869-1.7981zm-6.89 85.7673a1.805 1.805 0 0 1 -1.9591 1.8052c-8.5279-.7334-21.4633-1.56-37.8411-1.7518l-2.068-2.3077v-10.954a1.4977 1.4977 0 0 0 -1.4977-1.4977h-6.246a1.4977 1.4977 0 0 0 -1.4977 1.4977v10.954l-2.0618 2.3009c-16.4586.1728-29.3172.9925-37.7881 1.7306-.0068.0006-.0133-.0009-.02 0l-1.9416-2.1667v-75.1723l2.3328-2.6036c8.1982-.72 21.1767-1.6 37.3632-1.81l2.1155 2.3606v9.8347a1.4977 1.4977 0 0 0 1.4977 1.4977h6.2462a1.4977 1.4977 0 0 0 1.4977-1.4977v-9.8341l2.1231-2.3691c16.7989.1928 30.0152 1.1161 38.1066 1.8541a1.8036 1.8036 0 0 1 1.6385 1.804z' fill='%23fec307'/%3e %3ccircle cx='112.9451' cy='106.1517' fill='%23fec307' r='4.6207' transform='matrix(0.382683%2c -0.92388%2c 0.92388%2c 0.382683%2c -28.348499%2c 169.876694)'/%3e %3cpath d='m94.4884 75.2734h-12.9957a6.58 6.58 0 0 0 -6.58 6.58v51.18a6.58 6.58 0 0 0 6.58 6.58h12.9957a6.5794 6.5794 0 0 0 6.5794-6.5794v-27.37h-13.22a.6138.6138 0 0 0 -.6138.6137v6.0833a.6136.6136 0 0 0 .6138.6136h3.7308l1.2965 1.2966v16.78l-1.2517 1.2518h-7.26l-1.2574-1.2575v-47.1488l1.3129-1.3127h7.1486l1.3072 1.3071v13.7528a.6137.6137 0 0 0 .6137.6137h6.9655a.6136.6136 0 0 0 .6137-.6137v-15.7911a6.5794 6.5794 0 0 0 -6.5792-6.5794z' fill='%23fec307'/%3e %3cpath d='m143.4011 75.2734h-12.1766a6.58 6.58 0 0 0 -6.58 6.58v21.9459a5.5444 5.5444 0 0 0 4.1517 5.3667l11.8158 3.0663 1.1752 1.1751v17.7452l-1.1307 1.1306h-6.672l-1.1469-1.1468v-12.2488a.6137.6137 0 0 0 -.6138-.6137h-6.9656a.6137.6137 0 0 0 -.6137.6137v14.1264a6.58 6.58 0 0 0 6.58 6.58h12.1766a6.58 6.58 0 0 0 6.5794-6.58v-22.329a5.5445 5.5445 0 0 0 -4.164-5.37l-11.8181-3.0385-1.16-1.16v-17.3265l1.2055-1.2055h6.56l1.1841 1.1841v12.2107a.6137.6137 0 0 0 .6137.6137h6.9654a.6138.6138 0 0 0 .6138-.6137v-14.1265a6.5794 6.5794 0 0 0 -6.5798-6.5794z' fill='%23fec307'/%3e%3c/svg%3e" />
                    </NavigationLogo>
                </>}
                <Tabs>
                    {rightButtons.map((button, index) => (
                        <Tab key={index}>
                            <NavButton button={button} size="sm" />
                        </Tab>
                    ))}
                </Tabs>

            </InnerNavigation>

        </Navigation>

    </>
}